import { resetPassword } from '@backoffice-frontend/authentication'
import { createRoute, Routes } from '@backoffice-frontend/common'
import { Text } from '@moia-dev/pace-web'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { PublicAppViewContentLayout } from '../components/PublicAppViewContentLayout'
import { ForgotPasswordForm } from './ForgotPasswordForm'

export const ForgotPasswordView = ({ isMobile }: { isMobile: boolean }) => {
  const navigate = useNavigate()
  const [error, setError] = useState('')

  const handleSubmitForm = async ({ email = '' }) => {
    try {
      const output = await resetPassword({ username: email })
      if (
        output.nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE'
      ) {
        navigate(
          createRoute(Routes.Auth.SetNewPassword.url, { username: email }),
        )
      }
    } catch (_error) {
      const error = _error as { message: string }
      setError(error.message)
    }
  }

  const { t } = useTranslation()

  return (
    <PublicAppViewContentLayout
      title={t('loginView_forgotPassword_title')}
      isMobile={isMobile}
    >
      {error && (
        <Text size="md" color="critical">
          {error}
        </Text>
      )}
      <ForgotPasswordForm onSubmit={handleSubmitForm} isMobile={isMobile} />
    </PublicAppViewContentLayout>
  )
}
